import { DictionaryName } from 'types/Dictionary';

export const DICTIONARY_BASE_PATH = '/public/themes/default/dictionaries';

export const DICTIONARY_PATHS: Record<DictionaryName, string> = {
  [DictionaryName.PINYIN_SIMPLIFIED]: 'pinyin-simplified.json',
  [DictionaryName.PINYIN_TRADITIONAL]: 'pinyin-traditional.json',
  [DictionaryName.CANGJIE_TRADITIONAL]: 'cangjie-traditional.json',
};
